export const inputCls = "w-full rounded-lg bg-[#070912] border border-white/10 px-4 py-3 text-sm text-white placeholder:text-slate-600 outline-none focus:border-[#2f7bff] focus:shadow-[0_0_0_3px_rgba(47,123,255,0.18)] transition-colors";

export const PageHead = ({ label, t1, t2, sub, right }) => (
  <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 cx-rise">
    <div>
      <div className="cx-label">{label}</div>
      <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl mt-3 leading-[1.02]">
        <span className="cx-chrome">{t1}</span><span className="cx-text-grad">{t2}</span>
      </h1>
      {sub && <p className="text-slate-400 mt-4 text-sm sm:text-base max-w-2xl">{sub}</p>}
    </div>
    {right}
  </div>
);

const TONES = {
  new: "#3ad7ff", review: "#ffc94d", planned: "#a746ff", shipped: "#22e3a1", declined: "#ff4d6d",
  open: "#3ad7ff", answered: "#22e3a1", closed: "#64748b", improved: "#a746ff", fix: "#ffc94d",
  cyan: "#3ad7ff", slate: "#64748b", amber: "#ffc94d", green: "#22e3a1", rose: "#ff4d6d",
};

export const Chips = ({ items, value, onChange, testid }) => (
  <div className="flex flex-wrap gap-2" data-testid={testid}>
    {items.map(([k, label]) => (
      <button key={k} onClick={() => onChange(k)} data-testid={`${testid}-${k}`}
        className={`rounded-full px-4 py-1.5 text-xs border transition-colors ${value === k ? "bg-[#2f7bff]/20 border-[#2f7bff]/60 text-white" : "border-white/10 text-slate-400 hover:text-white"}`}>{label}</button>
    ))}
  </div>
);

export const Pill = ({ tone, children, testid }) => {
  const c = TONES[tone] || "#94a3b8";
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-mono uppercase tracking-wider border"
      style={{ color: c, borderColor: `${c}55`, background: `${c}14` }}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: c, boxShadow: `0 0 8px ${c}` }} />{children}
    </span>
  );
};

const uiLang = () => document.documentElement.lang || undefined;
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString(uiLang(), { day: "numeric", month: "long", year: "numeric" }) : "");
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString(uiLang(), { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "");

export const Page = ({ children }) => <div className="px-4 sm:px-6 lg:px-10 2xl:px-14 py-6 sm:py-10">{children}</div>;
